var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import { MenuItem } from '@mui/material';
import { MODOS, MENSAGENS, getNomeFormatado, validarCNPJ } from '../../../utils';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import ContainerPainel from '../../../components/container_painel';
import { BoxPrincipal, BoxBotoes } from '../../../components/form_box';
import Loading from '../../../components/loading';
import { useNavigate, useParams } from 'react-router-dom';
import { BotaoSalvar, BotaoExcluir, BotaoFechar, BotaoEditar } from '../../../components/botoes';
import InputDados from '../../../components/input_dados';
import { useAuth } from '../../../contexts/auth/AuthContext';
export var CadastroBasicoCNPJForm = function (_a) {
    var _b = _a.pagina, pagina = _b === void 0 ? PAGINAS.UNIDADES_PENITENCIARIAS : _b, _c = _a.paginaPermissao, paginaPermissao = _c === void 0 ? FUNCIONALIDADES.UNIDADES_PENITENCIARIAS : _c, _d = _a.rota, rota = _d === void 0 ? ROUTES.UNIDADES_PENITENCIARIAS : _d, services = _a.services;
    var _e = useAuth(), addMensagem = _e.addMensagem, getAcoesFuncionalidade = _e.getAcoesFuncionalidade;
    var acoesFuncionalidade = useMemo(function () { return getAcoesFuncionalidade(paginaPermissao || pagina); }, [getAcoesFuncionalidade, pagina, paginaPermissao]);
    var navigate = useNavigate();
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var _g = useState(true), loadingInicio = _g[0], setLoadingInicio = _g[1];
    var _h = useParams(), id = _h.id, modo = _h.modo;
    var _j = useState(''), nome = _j[0], setNome = _j[1];
    var _k = useState(''), cnpj = _k[0], setCNPJ = _k[1];
    var _l = useState('Ativo'), situacao = _l[0], setSituacao = _l[1];
    var desabilitarCampos = modo === MODOS.VISUALIZAR || modo === MODOS.EXCLUIR;
    useEffect(function () {
        carregarDados();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!id) return [3 /*break*/, 2];
                    return [4 /*yield*/, services.getItem(id)];
                case 1:
                    resp = _a.sent();
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'ERRO') {
                        alert(resp.Mensagem);
                    }
                    else if (resp) {
                        setNome(resp.nome || '');
                        setCNPJ(resp.cnpj || '');
                        setSituacao(resp.situacao || 'Ativo');
                    }
                    _a.label = 2;
                case 2:
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var validarDados = function () {
        if (!nome || nome.trim() === '') {
            alert("Nome ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!cnpj || cnpj.trim() === '') {
            alert("CNPJ ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        var regexCNPJ = new RegExp(/^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/);
        if (!regexCNPJ.test(cnpj) || !validarCNPJ(cnpj)) {
            alert('O CNPJ informado é inválido');
            return false;
        }
        return true;
    };
    var salvarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var dados, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validarDados())
                        return [2 /*return*/];
                    setLoading(true);
                    dados = {
                        nome: getNomeFormatado(nome),
                        cnpj: cnpj.replace(/\D/g, ''),
                        situacao: situacao,
                    };
                    if (!(modo === MODOS.CADASTRAR)) return [3 /*break*/, 2];
                    return [4 /*yield*/, services.cadastrarItem(dados)];
                case 1:
                    resp = _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    if (!(modo === MODOS.ALTERAR)) return [3 /*break*/, 4];
                    return [4 /*yield*/, services.alterarItem(dados, id !== null && id !== void 0 ? id : '')];
                case 3:
                    resp = _a.sent();
                    _a.label = 4;
                case 4:
                    setLoading(false);
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        if (addMensagem) {
                            addMensagem(modo === MODOS.CADASTRAR ? MENSAGENS.REGISTRO_CADASTRADO_SUCESSO : MENSAGENS.REGISTRO_ALTERADO_SUCESSO);
                        }
                        navigate(rota);
                    }
                    else if (resp) {
                        alert(resp.Mensagem);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var excluirRegistro = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm(MENSAGENS.EXCLUIR_REGISTRO))
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, services.excluirItem(id !== null && id !== void 0 ? id : '')];
                case 1:
                    resp = _a.sent();
                    setLoading(false);
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        if (addMensagem)
                            addMensagem(MENSAGENS.REGISTRO_EXCLUIDO_SUCESSO);
                        navigate(rota);
                    }
                    else if (resp) {
                        alert(resp.Mensagem);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(ContainerPainel, __assign({ modo: modo, pagina_acima: pagina, pagina_especifica_permissao: paginaPermissao || pagina, link_pagina_acima: rota }, { children: _jsxs(BoxPrincipal, { children: [!loadingInicio && (_jsxs(_Fragment, { children: [_jsx(InputDados, { id: 'id', variant: 'outlined', disabled: true, label: 'C\u00F3digo', value: id, size: 'small' }), _jsx(InputDados, { id: 'nome', label: 'Nome', value: nome, onChange: function (e) { return setNome(e.target.value); }, variant: 'outlined', size: 'small', required: true, disabled: desabilitarCampos }), _jsx(InputDados, { id: 'cnpj', label: 'CNPJ', value: cnpj, onChange: function (e) { return setCNPJ(e.target.value); }, mask: '99.999.999/9999-99', variant: 'outlined', size: 'small', required: true, disabled: desabilitarCampos }), _jsxs(InputDados, __assign({ select: true, id: 'situacao', label: 'Situa\u00E7\u00E3o', value: situacao, onChange: function (e) { return setSituacao(e.target.value); }, size: 'small', disabled: desabilitarCampos }, { children: [_jsx(MenuItem, __assign({ value: 'Ativo' }, { children: "Ativo" })), _jsx(MenuItem, __assign({ value: 'Inativo' }, { children: "Inativo" }))] })), _jsxs(BoxBotoes, { children: [(modo === MODOS.ALTERAR || modo === MODOS.CADASTRAR) && _jsx(BotaoSalvar, { onClick: salvarDados }), modo === MODOS.EXCLUIR && _jsx(BotaoExcluir, { onClick: excluirRegistro }), modo === MODOS.VISUALIZAR && (_jsx(BotaoEditar, { onClick: function () { return navigate("".concat(rota, "/").concat(id, "/").concat(MODOS.ALTERAR)); }, disabled: !acoesFuncionalidade['ALTERAR'] })), _jsx(BotaoFechar, { modo: modo })] })] })), loading && _jsx(Loading, {})] }) })));
};
export default CadastroBasicoCNPJForm;
